import { Box } from '@material-ui/core';
import ServiceHistory from './ServiceHistory';

const TransactionHistory = () => {
  return (
    <Box p="1.87rem 1.87rem 0">
      <ServiceHistory />
    </Box>
  );
};

export default TransactionHistory;
